"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterCriteria = void 0;
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
/**
 * It contains information about modal filters for Assessment/Section Reports
 *
 * @property {string[]}  sections     - list of selected sections
 * @property {string[]}  modules      - list of selected modules
 * @property {string[]}  assessments  - list of selected assessments
 * @property {string[]}  students  - list of selected students
 */
var FilterCriteria = /** @class */ (function () {
    function FilterCriteria(data) {
        if (data === void 0) { data = {}; }
        this.sections = [];
        this.modules = [];
        this.assessments = [];
        this.students = [];
        Object.assign(this, data);
    }
    FilterCriteria.prototype.hasSections = function () {
        return !(0, isEmpty_1.default)(this.sections);
    };
    FilterCriteria.prototype.hasModules = function () {
        return !(0, isEmpty_1.default)(this.modules);
    };
    FilterCriteria.prototype.hasAssessments = function () {
        return !(0, isEmpty_1.default)(this.assessments);
    };
    FilterCriteria.prototype.hasStudents = function () {
        return !(0, isEmpty_1.default)(this.students);
    };
    FilterCriteria.prototype.isDirty = function () {
        return this.hasSections() || this.hasModules() || this.hasAssessments();
    };
    return FilterCriteria;
}());
exports.FilterCriteria = FilterCriteria;
